


class GrassCalculatorController {
  constructor() {
    this.widthOptions = document.querySelectorAll('.grass-calculator__width-option');
    this.lengthSelector = document.querySelector('.grass-calculator__length-selector select');

    this.totalAreaEl = document.querySelector('.grass-calculator__total-area');
    this.totalPriceEl = document.querySelector('.grass-calculator__total-price');
    
    // Find both desktop and mobile price elements
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    const mobileTitleWrapper = document.querySelector('.product__mobile-title-wrapper');
    
    this.desktopPriceEl = productInfoWrapper ? productInfoWrapper.querySelector('.f-price--large') || productInfoWrapper.querySelector('.f-price') : null;
    this.mobilePriceEl = mobileTitleWrapper ? mobileTitleWrapper.querySelector('.f-price--large') || mobileTitleWrapper.querySelector('.f-price') : null;
    
    this.calculatorPriceEl = document.querySelector('.grass-calculator__product-price');

    const { productId, productPrice } = document.querySelector('.grass-calculator').dataset;

    this.productId = productId;
    this.productPrice = Number(productPrice);

    this.addToCartBtn = document.querySelector('.grass-calculator__add-to-cart');
    this.buyNowBtn = document.querySelector('.grass-calculator__buy-now');

    this.orderOverviewEl = document.querySelector('#grass-calculator__order-overview');
    this.orderOverviewPricePerMeter = document.querySelector('#grass-calculator__order-overview-price-per-meter');
    this.orderOverviewProductAmount = document.querySelector('#grass-calculator__order-overview-product-info-amount');
    this.orderOverviewProductPrice = document.querySelector('#grass-calculator__order-overview-product-info-price');

    this.addToCartBtnEl = document.querySelector('#add-to-cart-btn');
    this.closeOrderOverviewBtn = document.querySelector('.grass-calculator__order-overview-close-btn');
    this.continueShoppingBtn = document.querySelector('.grass-calculator__order-overview-actions .continue-shopping');

    this.errorScreenContainer = document.querySelector('#grass-calculator__error-screen');
    this.errorScreenTitle = document.querySelector('#grass-calculator__error-screen-title');
    this.errorScreenDescription = document.querySelector('#grass-calculator__error-screen-description');
    this.errorScreenConfirmBtn = document.querySelector('#grass-calculator__error-screen-confirm-btn');

    this.selectedVariant;
    this.selectedVariantQuantity;
    this.selectedWidth;
    this.selectedLength;
  }

  init() {
    // Check if we have width options
    if (this.widthOptions.length === 0) {
      console.warn('No width options found for grass calculator');
      return;
    }

    this.widthOptions[0].classList.add('selected');
    this.selectedVariant = this.widthOptions[0].dataset.variantId;
    this.selectedVariantQuantity = this.widthOptions[0].dataset.variantQuantity;
    this.selectedWidth = Number(this.widthOptions[0].dataset.width);
    this.selectedVariantPrice = Number(this.widthOptions[0].dataset.variantPrice / 100) * 2;

    const priceText = `£${(Number(this.widthOptions[0].dataset.variantPrice / 100) * 2).toFixed(2)} per m2`;

    // Update both desktop and mobile price displays
    if (this.desktopPriceEl) {
      this.desktopPriceEl.innerHTML = priceText;
    }
    if (this.mobilePriceEl) {
      this.mobilePriceEl.innerHTML = priceText;
    }
    if (this.calculatorPriceEl) {
      this.calculatorPriceEl.innerHTML = priceText;
    }

    this._renderLengthOptions();

    this.lengthSelector.value = "1.0";
    this.selectedLength = Number(this.lengthSelector.value);

    this._handleValueUpdate();

    // Add event listeners to width options
    for (let i = 0; i < this.widthOptions.length; i++) {
      const widthOption = this.widthOptions[i];

      widthOption.addEventListener('click', () => {
        this._resetWidthSelection();

        widthOption.classList.add('selected');

        this.selectedWidth = widthOption.dataset.width;
        this.selectedVariant = widthOption.dataset.variantId;
        this.selectedVariantQuantity = widthOption.dataset.variantQuantity;
        this.selectedVariantPrice = (Number(widthOption.dataset.variantPrice) / 100) * 2;

        const priceText = `£${(Number(widthOption.dataset.variantPrice / 100) * 2).toFixed(2)} per m2`;

        // Update both desktop and mobile price displays
        if (this.desktopPriceEl) {
          this.desktopPriceEl.innerHTML = priceText;
        }
        if (this.mobilePriceEl) {
          this.mobilePriceEl.innerHTML = priceText;
        }
        if (this.calculatorPriceEl) {
          this.calculatorPriceEl.innerHTML = priceText;
        }

        this._renderLengthOptions();
        this._handleValueUpdate();
      });
    }

    // Add event listeners
    if (this.lengthSelector) {
      this.lengthSelector.addEventListener('change', () => {
        this.selectedLength = Number(this.lengthSelector.value);
        this._handleValueUpdate();
      });
    }

    if (this.closeOrderOverviewBtn) {
      this.closeOrderOverviewBtn.addEventListener('click', () => {
        this.hideOrderOverview();
      });
    }

    if (this.continueShoppingBtn) {
      this.continueShoppingBtn.addEventListener('click', () => {
        this.hideOrderOverview();
      });
    }

    if (this.errorScreenConfirmBtn) {
      this.errorScreenConfirmBtn.addEventListener('click', () => {
        this.errorScreenContainer.classList.remove('active');
      });
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', this._addToCart.bind(this));
    }

    if (this.buyNowBtn) {
      this.buyNowBtn.addEventListener('click', this.orderASample.bind(this));
    }
  }

  handleError(error) {
    const { message, description } = error;

    if (this.errorScreenTitle) {
      this.errorScreenTitle.innerHTML = message;
    }
    if (this.errorScreenDescription) {
      this.errorScreenDescription.innerHTML = description;
    }
    if (this.errorScreenContainer) {
      this.errorScreenContainer.classList.add('active');
    }
  }

  hideOrderOverview() {
    if (this.orderOverviewEl) {
      this.orderOverviewEl.classList.remove('active');
    }
  }

  async _addToCart() {
    let formData = {
      'items': [{
        'id': this.selectedVariant,
        'quantity': (this.selectedWidth * this.selectedLength).toFixed(1) * 2,
        'properties': {
          'width': `${this.selectedWidth}m`,
          'length': `${this.selectedLength}m`
        }
      }]
    };

    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const orderRequest = await res.json();

    if (orderRequest.status === 422) {
      this.handleError(orderRequest);
    } else {
      const totalArea = this._calculateTotalArea(this.selectedWidth, this.selectedLength);
      if (this.orderOverviewProductAmount) {
        this.orderOverviewProductAmount.innerHTML = `${totalArea} m2`;
      }
      if (this.orderOverviewProductPrice) {
        this.orderOverviewProductPrice.innerHTML = `£${(totalArea * this.selectedVariantPrice).toFixed(2)}`;
      }
      if (this.orderOverviewPricePerMeter) {
        this.orderOverviewPricePerMeter.innerHTML = this.selectedVariantPrice.toFixed(2);
      }

      if (this.orderOverviewEl) {
        this.orderOverviewEl.classList.add('active');
      }
    }
  }

  async orderASample(e) {
    const { sampleUrl } = e.target.dataset;

    window.location.href = sampleUrl || '/collections/samples';
  }

  _renderLengthOptions() {
    const maxLength = 25;

    if (!this.lengthSelector) {
      console.warn('Length selector not found for grass calculator');
      return;
    }

    this.lengthSelector.innerHTML = '';

    let lengthSelectorOptions = '';

    for (let index = 0.5; index <= maxLength; index += 0.5) {
      lengthSelectorOptions += `<option value="${index.toFixed(1)}" ${index === this.selectedLength ? 'selected' : ''}>${index}m</option>`
    }

    this.lengthSelector.innerHTML = lengthSelectorOptions;
  }

  _handleValueUpdate() {
    if (!this.totalAreaEl || !this.totalPriceEl) {
      console.warn('Total area or total price elements not found for grass calculator');
      return;
    }

    const totalArea = this._calculateTotalArea(this.selectedWidth, this.selectedLength);

    this.totalAreaEl.innerHTML = `${totalArea} m2`;
    this.totalPriceEl.innerHTML = `£${(totalArea * this.selectedVariantPrice).toFixed(2)}`;
  }

  _calculateTotalArea(width, length) {
    return Number(width) * Number(length);
  }

  _resetWidthSelection() {
    for (let i = 0; i < this.widthOptions.length; i++) {
      const widthOption = this.widthOptions[i];
      widthOption.classList.remove('selected');
    }
  }
}